// image.service.ts
import { Component, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class CreditsService {

  constructor(private http: HttpClient) {}
  getCredits(id: number, type: string, lang: string = 'en-US'): Observable<any> {
    return this.http.get<any>(`${environment.backendUrl}/api/${type}/${id}/credits?language=${lang}`);
  }

  


}